/* eslint-disable no-console */
export default class Operation {
  // N° de operación
  setOperationNumber(value) {
    if (!value) throw new Error('invalid operationNumber');
    this.operationNumber = value;
    return this;
  }

  // Nro Operación SVS
  setCompanyOperationId(value) {
    if (!value) {
      throw new Error('invalid companyOperationId');
    }
    this.companyOperationId = value;
    return this;
  }

  // Nro Operación Andes
  setAndesCompanyOperationId(value) {
    if (!value) throw new Error('invalid andesCompanyOperationId');
    this.andesCompanyOperationId = value;
    return this;
  }

  // Subtipo de operación
  setSubTypeOperation(value) {
    const subTypes = {
      INVERSIONISTA: 'INVESTMENT',
      'PRIMERA VIVIENDA': 'FIRST_HOME',
      SUBSIDIO: 'SUBSIDY'
    };
    const subType = value.trim().toUpperCase();
    const isInvalidSubType = !Object.keys(subTypes).includes(subType);
    if (isInvalidSubType) throw new Error('invalid segment or subtype: ', value);
    this.subType = subTypes[subType];
    return this;
  }

  // Nombre Inversionista
  setOrigin() {
    // El origen para mortgage se asume creditu cómo el primer dueño de la operación
    this.origin = 'CREDITU';
    return this;
  }

  // Fecha firma deudor
  setDebtorSignatureDate(value) {
    this.debtorSignatureDate = value;
    return this;
  }

  // Tasa de emisión
  setEmissionRate(value) {
    this.emissionRate = value;
    return this;
  }

  // CAE
  setEAC(value) {
    this.EAC = value;
    return this;
  }

  // Plazo de crédito
  setTermAsMonths(value, country) {
    if (!value) throw new Error('invalid termAsMonths');
    this.termAsMonths = country === 'cl' ? (Number(value) * 12).toString() : value;
    return this;
  }

  // Meses de gracia
  setGraceMonths(value) {
    this.graceMonths = value;
    return this;
  }

  // Precio venta
  setPropertyAmount(value) {
    this.propertyAmount = value;
    return this;
  }

  // Total crédito
  setAprovedAmount(value) {
    if (!value) throw new Error('invalid approvedAmount');
    this.approvedAmount = value;
    return this;
  }

  // Monto crédito sin póliza
  setUninsuredCreditAmount(value) {
    this.uninsuredCreditAmount = value;
    return this;
  }

  // Valor cuota
  setPaymentValue(value) {
    this.paymentValue = value;
    return this;
  }

  // N° de póliza desgravamen deudor
  setDebtorLifeInsuranceNumber(value) {
    this.debtorLifeInsuranceNumber = value;
    return this;
  }

  // N° de póliza desgravamen codeudor
  setCodebtorLifeInsuranceNumber(value) {
    this.codebtorLifeInsuranceNumber = value;
    return this;
  }

  // Segmento
  setSegment(value) {
    this.segment = value;
    return this;
  }

  // Tipo de Subsidio
  setSubsidyType(value) {
    this.subsidyType = value || '';
    return this;
  }

  // Valor subsidio
  setSubsidyValue(value) {
    this.subsidyValue = value;
    return this;
  }

  // Dirección propiedad
  setPropertyAddress(value) {
    this.propertyAddress = value;
    return this;
  }

  // Unidad de la propiedad
  setPropertyUnit(value) {
    this.propertyUnit = value;
    return this;
  }

  // Comuna
  setCommune(value) {
    this.commune = value;
    return this;
  }

  // Ciudad
  setCity(value) {
    this.city = value;
    return this;
  }

  // Proyecto
  setProjectName(value) {
    this.projectName = value;
    return this;
  }

  // Tipo de propiedad
  setPropertyType(value) {
    this.propertyType = value;
    return this;
  }

  // Valor tasación departamento
  setPropertyAppraisal(value) {
    this.propertyAppraisal = value;
    return this;
  }

  // Valor tasación terreno
  setTerrainAppraisal(value) {
    this.terrainAppraisal = value;
    return this;
  }

  // Valor tasación bodega
  setCellarAppraisal(value) {
    this.cellarAppraisal = value;
    return this;
  }

  // Valor tasación estacionamiento
  setParkingLotAppraisal(value) {
    this.parkingLotAppraisal = value;
    return this;
  }

  // Valor tasación total
  setAppraisalTotal(value) {
    this.appraisalTotal = value;
    return this;
  }

  // Fecha tasación
  setAppraisalDate(value) {
    this.appraisalDate = value;
    return this;
  }

  // Valor asegurable departamento
  setInsurablePropertyValue(value) {
    this.insurablePropertyValue = value;
    return this;
  }

  // Valor asegurable terreno
  setInsurableTerrainValue(value) {
    this.insurableTerrainValue = value;
    return this;
  }

  // Valor asegurable bodega
  setInsurableCellarValue(value) {
    this.insurableCellarValue = value;
    return this;
  }

  // Valor asegurable estacionamiento
  setInsurableParkingLotValue(value) {
    this.insurableParkingLotValue = value;
    return this;
  }

  // Valor asegurable total
  setInsurableValueTotal(value) {
    this.insurableValueTotal = value;
    return this;
  }

  // Dividendo renta total
  setFrontEndRatioTotal(value) {
    this.frontEndRatioTotal = value;
    return this;
  }

  // Carga financiera total
  setBackendRatioTotal(value) {
    this.backendRatioTotal = value;
    return this;
  }

  // Porcentaje LTV
  setLoanToValuePercentage(value) {
    this.loanToValuePercentage = value;
    return this;
  }

  // Porcentaje LTV total con póliza
  setInsuredLoanToValuePercentage(value) {
    this.insuredLoanToValuePercentage = value;
    return this;
  }

  // Notaria
  setNotary(value) {
    this.notary = value;
    return this;
  }

  // CBR
  setRealStateConservator(value) {
    this.realStateConservator = value;
    return this;
  }

  // Fojas (Inscripcion CBR)
  setRealStateConservatorRegistrationSheet(value) {
    this.realStateConservatorRegistrationSheet = value;
    return this;
  }

  // Numero (Inscripcion CBR)
  setRealStateConservatorRegistrationNumber(value) {
    this.realStateConservatorRegistrationNumber = value;
    return this;
  }

  // Año (Inscripcion CBR)
  setRealStateConservatorRegistrationYear(value) {
    this.realStateConservatorRegistrationYear = value;
    return this;
  }

  // Fecha firma salida CBR
  setRealStateConservatorExitSignatureDate(value) {
    this.realStateConservatorExitSignatureDate = value;
    return this;
  }

  // Fecha de timbre endoso
  setStampEndorsementDate(value) {
    this.stampEndorsementDate = value;
    return this;
  }

  // ROL
  setRole(value) {
    this.role = value;
    return this;
  }

  // DPS deudor
  setDebtorDPS(value) {
    this.debtorDPS = value;
    return this;
  }

  // DPS Codeudor
  setCodebtorDPS(value) {
    this.codebtorDPS = value;
    return this;
  }

  // Tipo deudor
  setDebtorType(value) {
    this.debtorType = value;
    return this;
  }

  // Nombre deudor
  setDebtorName(value) {
    this.debtorName = value;
    return this;
  }

  // Primer apellido deudor
  setDebtorLastName(value) {
    this.debtorLastName = value;
    return this;
  }

  // Segundo apellido deudor
  setDebtorSecondLastName(value) {
    this.debtorSecondLastName = value;
    return this;
  }

  // Rut deudor
  setDebtorIdNumber(value) {
    if (!value) throw new Error('invalid debtorIdNumber');
    this.debtorIdNumber = value;
    return this;
  }

  // Fecha de nacimiento deudor
  setDebtorBirthdate(value) {
    this.debtorBirthdate = value;
    return this;
  }

  // Genero deudor
  setDebtorGender(value) {
    this.debtorGender = value;
    return this;
  }

  // Estado civil deudor
  setDebtorMaritalStatus(value) {
    this.debtorMaritalStatus = value;
    return this;
  }

  // Regimen conyugal deudor
  setDebtorConjugalRegime(value) {
    this.debtorConjugalRegime = value;
    return this;
  }

  // TIPO TRABAJADOR deudor
  setDebtorWorkerType(value) {
    this.debtorWorkerType = value;
    return this;
  }

  // NACIONALIDAD deudor
  setDebtorNationality(value) {
    this.debtorNationality = value;
    return this;
  }

  // PROFESION deudor
  setDebtorProfession(value) {
    this.debtorProfession = value;
    return this;
  }

  // Dirección deudor
  setDebtorAddress(value) {
    this.debtorAddress = value;
    return this;
  }

  // Código Posatal deudor
  setDebtorAddressCEP(value) {
    this.debtorAddressCEP = value;
    return this;
  }

  // Comuna de dirección deudor
  setDebtorAddressCommune(value) {
    this.debtorAddressCommune = value;
    return this;
  }

  // Teléfono deudor
  setDebtorPhone(value) {
    this.debtorPhone = value;
    return this;
  }

  // Correo electrónico deudor
  setDebtorEmail(value) {
    this.debtorEmail = value;
    return this;
  }

  // Sueldo mensual deudor
  setDebtorMonthlySalary(value) {
    this.debtorMonthlySalary = value;
    return this;
  }

  // Nombre codeudor
  setCodebtorName(value) {
    this.codebtorName = value;
    return this;
  }

  // Primer apellido codeudor
  setCodebtorLastName(value) {
    this.codebtorLastName = value;
    return this;
  }

  // Segundo apellido codeudor
  setCodebtorSecondLastName(value) {
    this.codebtorSecondLastName = value;
    return this;
  }

  // Rut codeudor
  setCodebtorIdNumber(value) {
    this.codebtorIdNumber = value;
    return this;
  }

  // Fecha de nacimiento codeudor
  setCodebtorBirthdate(value) {
    this.codebtorBirthdate = value;
    return this;
  }

  // Genero codeudor
  setCodebtorGender(value) {
    this.codebtorGender = value;
    return this;
  }

  // Dirección codeudor
  setCodebtorAddress(value) {
    this.codebtorAddress = value;
    return this;
  }

  // Comuna de dirección codeudor
  setCodebtorAddressCommune(value) {
    this.codebtorAddressCommune = value;
    return this;
  }

  // Teléfono codeudor
  setCodebtorAddressPhone(value) {
    this.codebtorAddressPhone = value;
    return this;
  }

  // Correo electrónico codeudor
  setCodebtorEmail(value) {
    this.codebtorEmail = value;
    return this;
  }

  // Sueldo mensual codeudor
  setCodebtorMonthlySalary(value) {
    this.codebtorMonthlySalary = value;
    return this;
  }

  // tipo trabajador codeudor
  setCodebtorWorkerType(value) {
    this.codebtorWorkerType = value;
    return this;
  }

  // Estado civil codeudor
  setCodebtorMaritalStatus(value) {
    this.codebtorMaritalStatus = value;
    return this;
  }

  // Regimen conyugal codeudor
  setCodebtorConjugalRegime(value) {
    this.codebtorConjugalRegime = value;
    return this;
  }

  // Nacionalidad Codeudor
  setCodebtorNationality(value) {
    this.codebtorNationality = value;
    return this;
  }

  // Profesión codeudor
  setCodebtorProfession(value) {
    this.codebtorProfession = value;
    return this;
  }

  // Fecha pago Inversionista
  setInvestorPaymentDate(value) {
    this.investorPaymentDate = value;
    return this;
  }

  // Nombre Inversionista
  setInvestorName(value) {
    this.investorName = value || 'CREDITU';
    return this;
  }

  // Fecha primera firma
  setFirstSignatureDate(value) {
    this.firstSignatureDate = value;
    return this;
  }

  // N.º Repertorio
  setRepertoireNumber(value) {
    this.repertoireNumber = value;
    return this;
  }

  // Tope Inflacionario
  setInflationaryUpperBound(value) {
    this.inflationaryUpperBound = value;
    return this;
  }

  // Tipo de Amortizacion
  setAmortizationMethod(value) {
    this.amortizationMethod = value;
    return this;
  }

  // Dia de vencimiento de cuota
  setDueDay(value) {
    this.dueDay = value;
    return this;
  }

  // Meses a añadir a la fecha de primera cuota
  setFirstDueDateMonthsToAdd(value) {
    this.firstDueDateMonthsToAdd = value;
    return this;
  }

  // Tipo de préstamo
  setType(value) {
    this.type = value;
    return this;
  }

  // BR - Activación de la operación
  setIsActive(value) {
    this.isActive = value;
    return this;
  }

  // BR - Fecha del primer pago
  setFirstPayment(value) {
    this.firstPayment = value;
    return this;
  }

  // BR - Seguro de la propiedad
  setPropertyInsuranceType(value) {
    this.propertyInsuranceType = value;
    return this;
  }

  // BR - Seguro de vida del deudor
  setDebtorLifeInsuranceType(value) {
    this.debtorLifeInsuranceType = value;
    return this;
  }

  // BR - Seguro de vida del codeudor
  setCodebtorLifeInsuranceType(value) {
    this.codebtorLifeInsuranceType = value;
    return this;
  }

  // BR - Seguro de vida del codeudor por proporción
  setCodebtorLifeInsuranceProportion(value) {
    this.codebtorLifeInsuranceProportion = value;
    return this;
  }

  // BR - Tasa de interés anual
  setAnnualRate(value) {
    this.annualRate = value;
    return this;
  }

  // BR - Fecha firma deudor
  setSignatureDate(value) {
    if (!value) throw new Error('invalid signatureDate');
    this.signatureDate = value;
    return this;
  }

  // BR - Tipo de CAP
  setUpperBoundBehaviour(value) {
    this.upperBoundBehaviour = value;
    return this;
  }

  // SME
  setPayments(payments) {
    if (!payments || payments.length === 0) throw new Error('invalid payments');
    this.payments = payments.map((payment, i) => {
      if (!payment.amortization) throw new Error(`Payment number ${i + 1} must have amortization`);
      if (!payment.interest) throw new Error(`Payment number ${i + 1} must have interest`);
      if (!payment.monthlyPayment) throw new Error(`Payment number ${i + 1} must have monthlyPayment`);
      if (!payment.paymentNumber) throw new Error(`Payment number ${i + 1} must have paymentNumber`);
      if (!payment.balance) throw new Error(`Payment number ${i + 1} must have balance`);
      if (payment.isPaid !== false) throw new Error(`Payment number ${i + 1} must have isPaid key on false`);
      return payment;
    });
    return this;
  }

  // NEMOTECNICO
  setMnemonic(value) {
    this.mnemonic = value || '';
    return this;
  }

  // Nº OPERACIÓN
  // CODIGO EMISOR
  setIssuingCode(value) {
    this.issuingCode = value || '';
    return this;
  }

  // FILLER1
  setFiller1(value) {
    this.filler1 = value || '';
    return this;
  }

  // FILLER2
  setFiller2(value) {
    this.filler2 = value || '';
    return this;
  }

  // FILLER3
  setFiller3(value) {
    this.filler3 = value || '';
    return this;
  }

  // NOMBRE TABLA DESARROLLO
  setAmortizationScheduleName(value) {
    this.amortizationScheduleName = value || '';
    return this;
  }

  // TASA EMISION CONTRATO
  // FECHA EMISION CONTRATO
  // FECHA VENCIMIENTO CONTRATO
  setContractExpirationDate(value) {
    this.contractExpirationDate = value || '';
    return this;
  }
  // PLAZO CREDITO
  // VALOR NOMINAL

  // TASA COMPRA ACTIVO
  setAssetPurchaseRate(value) {
    this.assetPurchaseRate = value || '';
    return this;
  }

  // VALOR NOMINAL ACTUAL
  setActualApprovedAmount(value) {
    this.actualApprovedAmount = value || '';
    return this;
  }

  // FECHA COMPRA ACTIVO
  setAssetPurchaseDate(value) {
    this.assetPurchaseDate = value || '';
    return this;
  }

  // MONTO COMPRA ACTIVO
  setAssetPurchaseAmount(value) {
    this.assetPurchaseAmount = value || '';
    return this;
  }

  // TOTAL AMORTIZADO
  setAmortizedTotal(value) {
    this.amortizedTotal = value || '';
    return this;
  }

  // MONTO ASEGURADO INCENDIO
  setInsuredAmount(value) {
    this.insuredAmount = value || '';
    return this;
  }

  // VALOR PAR FECHA COMPRA
  setEvenValueOnPurchaseDate(value) {
    this.evenValueOnPurchaseDate = value || '';
    return this;
  }

  // VALOR PRESENTE FECHA COMPRA
  setActualValueOnPurchaseDate(value) {
    this.actualValueOnPurchaseDate = value || '';
    return this;
  }

  // ACTIVO TRANSITORIO
  setTemporaryAsset(value) {
    this.temporaryAsset = value || '';
    return this;
  }

  // PASIVO TRANSITORIO
  setTemporaryLiability(value) {
    this.temporaryLiability = value || '';
    return this;
  }

  // CAPITAL CONTABLE
  setContableEquity(value) {
    this.contableEquity = value || '';
    return this;
  }

  // FECHA DEVENGO
  setEarnDate(value) {
    this.earnDate = value || '';
    return this;
  }

  // VALOR PAR FECHA DEVENGO
  setEvenValueOnEarnDate(value) {
    this.evenValueOnEarnDate = value || '';
    return this;
  }

  // VALOR PAR CORTO PLAZO
  setShortTermEvenValue(value) {
    this.shortTermEvenValue = value || '';
    return this;
  }

  // VALOR PAR LARGO PLAZO
  setLongTermEvenValue(value) {
    this.longTermEvenValue = value || '';
    return this;
  }

  // PASIVO DEVENGADO
  setEarnLiability(value) {
    this.earnLiability = value || '';
    return this;
  }

  // ACTIVO DEVENGADO
  setEarnAsset(value) {
    this.earnAsset = value || '';
    return this;
  }

  // INTERES DEVENGADO
  setEarnInterest(value) {
    this.EarnInterest = value || '';
    return this;
  }

  // REAJUSTE DEVENGADO
  setEarnAdjustment(value) {
    this.earnAdjustment = value || '';
    return this;
  }

  // VALOR ASTERISCO
  setAsteriskValue(value) {
    this.steriskValue = value || '';
    return this;
  }

  // TASA MERCADO
  setMarketRate(value) {
    this.marketRate = value || '';
    return this;
  }

  // VALOR TIR MERCADO
  setMarketIRR(value) {
    this.marketIRR = value || '';
    return this;
  }

  // VALOR TIR DELTA
  setDeltaIRR(value) {
    this.deltaIRR = value || '';
    return this;
  }

  // FECHA ULTIMO PREPAGO
  setLastPrepaidDate(value) {
    this.lastPrepaidDate = value || '';
    return this;
  }

  // MONTO ULTIMO PREPAGO
  setLastPrepaidAmount(value) {
    this.lastPrepaidAmount = value || '';
    return this;
  }

  // FECHA ULTIMA ACTUALIZACION
  setLastUpdateDate(value) {
    this.lastUpdateDate = value || '';
    return this;
  }

  // FECHA NUEVO ADMINISTRADOR
  setNewManagerDate(value) {
    this.newManagerDate = value || '';
    return this;
  }

  // FECHA COBRANZA JUDICIAL
  setJudicialCollection(value) {
    this.judicialCollection = value || '';
    return this;
  }

  // FECHA ULTIMO PAGO
  setLastPaymentDate(value) {
    this.lastPaymentDate = value || '';
    return this;
  }

  // ORIGINADOR
  setOriginator(value) {
    this.originator = value || '';
    return this;
  }

  // PATRIMONIO
  setEquity(value) {
    this.equity = value || '';
    return this;
  }

  // EVALUADOR
  setAppraiser(value) {
    this.appraiser = value || '';
    return this;
  }

  // CUOTA ULTIMO PAGO
  setLastMonthlyPayment(value) {
    this.lastMonthlyPayment = value || '';
    return this;
  }

  // VALOR AJUSTE DE MERCADO
  setMarketAdjustmentValue(value) {
    this.marketAdjustmentValue = value || '';
    return this;
  }

  // RUT DEUDOR
  setDebtorIdNumberWithoutVD(value) {
    this.idNumberWithoutVD = value || '';
    return this;
  }

  // RUT SECURITIZADORA-DEUDOR
  setDebtorSecuritizationCompanyIdNumber(value) {
    this.ebtorSecuritizationCompanyIdNumber = value || '';
    return this;
  }

  // RUT NOVADO
  setNovatedIdNumber(value) {
    this.novatedIdNumber = value || '';
    return this;
  }

  // RUT SECURITIZADORA-NOVADO
  setNovatedSecuritizationCompanyIdNumber(value) {
    this.novatedSecuritizationCompanyIdNumber = value || '';
    return this;
  }

  // RUT PATRIMONIO EN ADMINISTRACION
  setManagedEquityIdNumber(value) {
    this.managedEquityIdNumber = value || '';
    return this;
  }

  // RUT SECURITIZADORA
  setSecuritizationCompanyIdNumber(value) {
    this.securitizationCompanyIdNumber = value || '';
    return this;
  }

  // RUT CIA SEGURO INCENDIO
  setFireInsuranceCompanyIdNumber(value) {
    this.fireInsuranceCompanyIdNumber = value || '';
    return this;
  }

  // POLIZA INCENDIO
  setFireInsuranceNumber(value) {
    this.fireInsuranceNumber = value || '';
    return this;
  }

  // INDICADOR DE SEGURO INCENDIO
  setFireInsuranceIndicator(value) {
    this.fireInsuranceIndicator = value || '';
    return this;
  }

  // RUT CIA SEGURO DESGRAVAMEN
  setMortgageInsuranceCompanyIdNumber(value) {
    this.mortgageInsuranceCompanyIdNumber = value || '';
    return this;
  }

  // INDICADOR DE SEGURO DESGRAVAMEN
  setMortgageInsuranceIndicator(value) {
    this.mortgageInsuranceIndicato = value || '';
    return this;
  }

  // POLIZA DESGRAVAMEN DEUDOR
  setMorgageInsuranceNumber(value) {
    this.morgageInsuranceNumber = value || '';
    return this;
  }

  // RUT CIA SEGURO CESANTIA/INC. TEMPORAL
  setTransitoryUnemploymentInsuranceCompanyIdNumber(value) {
    this.transitoryUnemploymentInsuranceCompanyIdNumber = value || '';
    return this;
  }

  // POLIZA CESANTIA/INCAPACIDAD TEMPORAL
  setTransitoryUnemploymentInsuranceNumber(value) {
    this.transitoryUnemploymentInsuranceNumber = value || '';
    return this;
  }

  // INDICADOR DE SEGURO CESANTIA/INC. TEMPORAL
  setTransitoryUnemploymentInsuranceIndicator(value) {
    this.transitoryUnemploymentInsuranceIndicator = value || '';
    return this;
  }

  // TIPO REAJUSTE
  setReadjustmentType(value) {
    this.readjustmentType = value || '';
    return this;
  }

  // BASE CALCULO COMPRA
  setPurchaseCalculationBase(value) {
    this.purchaseCalculationBase = value || '';
    return this;
  }

  // BASE CALCULO MERCADO
  setMarketCalculationBase(value) {
    this.marketCalculationBase = value || '';
    return this;
  }

  // ESTADO ACTIVO
  setActiveStatus(value) {
    this.activeStatus = value || '';
    return this;
  }

  // PERIODICIDAD
  setPeriodicity(value) {
    this.periodicity = value || '';
    return this;
  }

  // TIPO INSTRUMENTO
  setInstrumentType(value) {
    this.instrumentType = value || '';
    return this;
  }

  // CLASE INSTRUMENTO
  setInstrumentClass(value) {
    this.instrumentClass = value || '';
    return this;
  }

  // NOMBRE TASA VARIABLE
  setVariableRateName(value) {
    this.variableRateName = value || '';
    return this;
  }

  // PERIODICIDAD CAMBIO TASA
  setRateChangePeriodicity(value) {
    this.rateChangePeriodicity = value || '';
    return this;
  }

  // VIGENCIA ACTIVO
  setAssetValidity(value) {
    this.assetValidity = value || '';
    return this;
  }

  // ORIGINADOR
  setOriginator1(value) {
    this.originator1 = value || '';
    return this;
  }

  // NOMBRE TASA PENAL
  setLateChargesName(value) {
    this.lateChargesName = value || '';
    return this;
  }

  // TIPO TASA PENAL
  setLateChargesRateType(value) {
    this.lateChargesRateType = value || '';
    return this;
  }

  // TIPO TASA VARIALBLE
  setVariableRateType(value) {
    this.variableRateType = value || '';
    return this;
  }

  // INDICADOR TRASPASAR
  setTransferralIndicator(value) {
    this.transferralIndicator = value || '';
    return this;
  }

  // FECHA TRASPASO
  setTransferralDate(value) {
    this.transferralDate = value || '';
    return this;
  }

  // NUMERO VECES MOROSO
  setNumberOfDefaults(value) {
    this.numberOfDefaults = value || '';
    return this;
  }

  // FILLER4
  setFiller4(value) {
    this.filler4 = value || '';
    return this;
  }

  // FILLER5
  setFiller5(value) {
    this.filler5 = value || '';
    return this;
  }

  // FILLER6
  setFiller6(value) {
    this.filler6 = value || '';
    return this;
  }

  // DIAS CON MORA
  setDefaultingDays(value) {
    this.defaultingDays = value || '';
    return this;
  }

  // FECHA ULTIMA MOROSIDAD
  setLastDefaultingDate(value) {
    this.lastDefaultingDate = value || '';
    return this;
  }

  // VECES EN CJ
  setTimesInJudicialCollection(value) {
    this.timesInJudicialCollection = value || '';
    return this;
  }

  // FECHA ULTIMA CJ
  setLastJudicialCollectionDate(value) {
    this.lastJudicialCollectionDate = value || '';
    return this;
  }

  // FECHA ESTADO ACTIVO
  setActiveStateDate(value) {
    this.activeStateDate = value || '';
    return this;
  }

  // DIAS DE GRACIA
  setGraceDays(value) {
    this.graceDays = value || '';
    return this;
  }

  // PROXIMA CUOTA
  setNextPaymentNumber(value) {
    this.nextPaymentNumber = value || '';
    return this;
  }

  // PROXIMO VENCIMIENTO
  setNextPaymentDueDate(value) {
    this.nextPaymentDueDate = value || '';
    return this;
  }

  // DIA DE PAGO
  setPaymentDay(value) {
    this.paymentDay = value || '';
    return this;
  }

  // MONTO COMISION ADMINISTRACION
  setManagementCommissionAmount(value) {
    this.managementCommissionAmount = value || '';
    return this;
  }

  // INDICADOR DE SEGUROS
  setInsurancesIndicator(value) {
    this.insurancesIndicator = value || '';
    return this;
  }

  // FECHA PREJUDICIAL
  setPrejudicialDate(value) {
    this.prejudicialDate = value || '';
    return this;
  }

  // FECHA CARTERA VENCIDA
  setPortfolioExpirationDate(value) {
    this.portfolioExpirationDate = value || '';
    return this;
  }

  // VALOR DIVIDENDO
  setMonthlyPayment(value) {
    this.monthlyPayment = value || '';
    return this;
  }

  // FECHA CARTERA CASTIGADA
  setPortfolioPunishmentDate(value) {
    this.portfolioPunishmentDate = value || '';
    return this;
  }

  // VALOR TASA VARIABLE
  setVariableRate(value) {
    this.variableRate = value || '';
    return this;
  }

  // FECHA CAMBIO TASA VARIABLE
  setVariableRateChangeDate(value) {
    this.variableRateChangeDate = value || '';
    return this;
  }

  // NUMERO DE CUPONES
  setNumberOfCoupons(value) {
    this.numberOfCoupons = value || '';
    return this;
  }

  // FECHA AJUSTE
  setAdjustmentDate(value) {
    this.adjustmentDate = value || '';
    return this;
  }

  // FECHA VENTA
  setSaleDate(value) {
    this.saleDate = value || '';
    return this;
  }

  // CALCULA INTERES PENAL
  setCalculatesLateChargesInterest(value) {
    this.calculatesLateChargesInterest = value || '';
    return this;
  }

  // TASA INTERES PENAL
  setLateChargesInterestRate(value) {
    this.lateChargesInterestRate = value || '';
    return this;
  }

  // FECHA NOVACION DEUDOR
  setDebtorNovationDate(value) {
    this.debtorNovationDate = value || '';
    return this;
  }

  // TIPO ACTIVO
  setAssetType(value) {
    this.assetType = value || '';
    return this;
  }

  // FILLER7
  setFiller7(value) {
    this.filler7 = value || '';
    return this;
  }

  // OBSERVACIONES A LA CARGA
  setChargeObservations(value) {
    this.chargeObservations = value || '';
    return this;
  }

  // SALDO REAL
  setActualBalance(value) {
    this.actualBalance = value || '';
    return this;
  }

  // VENCIMIENTO ULTIMA CUOTA PAGADA
  setLastPaymentDueDate(value) {
    this.lastPaymentDueDate = value || '';
    return this;
  }

  // TASA EFECTIVA COMPRA
  setActualPurchaseRate(value) {
    this.actualPurchaseRate = value || '';
    return this;
  }

  // FECHA REAJUSTE
  setReadjustmentDate(value) {
    this.readjustmentDate = value || '';
    return this;
  }

  // MONTO SUBSIDIO
  // Tipo de Subsidio
  // NEMOTECNICO_1

  setFieldsFromRegisterProcess(value) {
    this.fieldsFromRegisterProcess = {
      operationData: value.operationData,
      debtor: value.debtor,
      household: value.household,
      warranty: value.warranty,
      paymentsHeader: value.paymentsHeader
    };
    return this;
  }

  setCreditInsuranceAmount(value) {
    if (value) {
      this.creditInsuranceAmount = value;
    }
    return this;
  }

  setMonthlyCreditInsurance(value) {
    if (value) {
      this.monthlyCreditInsurance = value;
    }
    return this;
  }

  setCreditInsuranceRate(value) {
    if (value) {
      this.creditInsuranceRate = value;
    }
    return this;
  }

  setCreditInsurancePrizeProportion(value) {
    if (value) {
      this.creditInsurancePrizeProportion = value;
    }
    return this;
  }

  setCreditInsuranceOuterProportion(value) {
    if (value) {
      this.creditInsuranceOuterProportion = value;
    }
    return this;
  }

  setCreditInsuranceNumberOfMonths(value) {
    if (value) {
      this.creditInsuranceNumberOfMonths = value;
    }
    return this;
  }

  setConsiderTAC(value) {
    if (value) {
      this.considerTAC = value;
    }
    return this;
  }

  setConsiderNegativeInflation(value) {
    if (value) {
      this.considerNegativeInflation = value;
    }
    return this;
  }
}
